export default {
    "add-new-review": "Add New Review",
    "rate-is-added": "rate is added"
}